<template>
  <hotline-messages @create="toggle_addition($event)" @cancel="toggle_addition(false)">
  </hotline-messages>
</template>

<script>

import HotlineMessages from "components/Hotline/List"
export default {
  name:"Hotline",

  components:{
    HotlineMessages
  },
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// client/views/Hotline/Hotline.vue